import React from 'react';
import { CallbackComponent } from 'redux-oidc';
import { connect } from 'react-redux';
import toastr from 'toastr';
import { userManager } from '../utils/user-manager';
import { bindActionCreators } from 'redux';
import actions from '../redux/actions/index';

class CallbackPage extends React.Component {
    successCallback(user) {
        this.props.history.push(user.state.returnTo);
    }

    errorCallback(error){
        toastr.error(error.message, 'We were unable to log you in', { timeOut: 0, extendedTimeOut: 0 });
        this.props.history.push('/');
    }

    render() {
        return (
            <CallbackComponent userManager={userManager} successCallback={this.successCallback.bind(this)}  errorCallback={this.errorCallback.bind(this)}>
                <div>
                Redirecting...
                </div>
            </CallbackComponent>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(CallbackPage);
